/**
 * 공통 코드 API
 */
import { apiClient } from "@/shared/api/client";
import { GetCommonCodeListResponseDto } from "@/shared/types/commonCode.types";

export const commonCodeApi = {
    /**
     * 그룹코드별 공통코드 목록 조회
     */
    getCommonCodeList: async (grpCode: string): Promise<GetCommonCodeListResponseDto> => {
        const response = await apiClient.get<GetCommonCodeListResponseDto>(
            '/api/v1/common-code/list',
            { params: { grpCode } }
        );
        return response.data;
    }
};
